<template>
    <v-container>
        <PageHeader :title="title" :items="items" :goBack="true" />
        <InformeDiarioComponente />
    </v-container>
</template>
<script>
//import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import InformeDiarioComponente from "./informe-diario-componente.vue";
export default {
    page: {
        title: "Informe Diario",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        //Layout,
        PageHeader,
        InformeDiarioComponente
    },
    data() {
        return {
            title: "Informe Diario",
            items: [
                {
                    text: "Proyectos",
                    href: `/proyectos/proyectos`,
                },
                {
                    text: "Lugares Instalación",
                    href: `/proyectos/lugaresInstalacion/${this.$route.params.codigoProyecto}`,
                },
                {
                    text: "Informe Diario",
                    active: true,
                },
            ],
        };
    },
};
</script>